export default __webpack_public_path__ + "static/media/Archway_Token_Red2.4598d1cc.png";